<template>
  <div class="number-modal">
    <div class="number-modal-body">
      <div class="number-body">
        <div class="number-body-title">
          <p>Утасны дугаар баталгаажуулах</p>
        </div>
        <div class="number-body-form">
          <form action="" @submit.prevent="sendNumber">
            <input
              type="text"
              placeholder="Утасны дугаар оруулна уу "
              v-on:keyup="checkNumber"
              v-model="number"
            />
            <div class="number-error" v-if="error">
              <p>{{ errorMessage }}</p>
            </div>
            <div class="row">
              <div class="col-md-6">
                <input
                  type="submit"
                  value="БАТАЛГААЖУУЛАХ"
                  :disabled="isDisabled"
                  :class="{ someSpace: error }"
                  style="display: block; width: 100%"
                />
              </div>
              <div class="col-md-6">
                <input
                  type="button"
                  value="ГАРАХ"
                  @click.esc="logout"
                  style="display: block; width: 100%"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="number-footer">
        <p>
          Утасны дугаар оруулснаар дараагийн удаад нэвтрэх түлхүүр үг болох
          боломжтой.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/EventBus.js";
export default {
  props: ["phone"],
  data() {
    return {
      number: "",
      error: false,
      errorMessage: "",
      isDisabled: false,
    };
  },
  methods: {
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    sendNumber() {
      this.isDisabled = true;
      var userNumber = this.number.replace(/\s/g, "");
      var isnum = /^\d+$/.test(userNumber);
      if (userNumber.length == 8 && isnum) {
        var tokenId = localStorage.getItem("authToken");
        if (tokenId == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        var typeValue = this.number;
        var userOwnData = this.$auth.getMe();
        var cardHolderKey = userOwnData.cardHolderInfId;
        this.$bonusApi
          .post(
            `auth/send/code/phone`,
            {
              tokenId,
              phoneNumber: typeValue,
              cardHolderKey,
              type: "NewUser",
            },
            {
              headers: {
                "Content-Type": "application/json",
                "Accept-Language": "mn",
              },
            }
          )
          .then((response) => {
            if (response.data === true) {
              this.$emit("close", typeValue);
            } else {
              this.errorMessage = "Код илгээхэд алдаа гарлаа.";
              this.error = true;
              this.isDisabled = false;
              this.$insProgress.finish();
            }
          })
          .catch((error) => {
            this.isDisabled = false;
            this.errorMessage =
              (error.response && error.response.data && error.response.data.message) ||
              "Код илгээхэд алдаа гарлаа.";
            this.error = true;
            this.$insProgress.finish();
          });
      } else {
        this.error = true;
        this.errorMessage = "Та зөвхөн 8 оронтой тоо оруулна уу.";
        this.isDisabled = true;
      }
    },
    logout() {
      this.RedirectLogin();
      this.$auth.destroyToken();
      this.$auth.removeMe();
      this.$router.push({ name: "login" });
    },
    checkNumber() {
      var number = this.number;
      var isnum = /^\d+$/.test(number);
      if (!isnum) {
        this.error = true;
        this.errorMessage = "Та зөвхөн тоо оруулна уу.";
        this.isDisabled = true;
      } else {
        this.error = false;
        this.errorMessage = "";
        this.isDisabled = false;
      }
    },
  },
};
</script>

<style scoped></style>
